export default "__VITE_ASSET__fq5iJtd9__"